import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import Modal from 'components/modal';
import ManagedInput from 'components/form/managed_input';

export const RenameModal = ({ shadow, onClose, onRename }) => {
  const [name, setName] = useState(shadow.name);

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        Rename to
      </Modal.Header>
      <Modal.Body>
        <ManagedInput
          autoFocus
          className="form-control"
          name="name"
          value={name}
          onValueChange={name => setName(name)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button label="Cancel" name="cancel" variant="ghost" onClick={onClose} />
        <Button label="Ok" name="ok" onClick={() => onRename(name)} />
      </Modal.Footer>
    </Modal>
  );
};

RenameModal.propTypes = {
  shadow: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onRename: PropTypes.func.isRequired,
};
